import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';

// Soglie per gli stati
const ALERT_THRESHOLD = 0;
const WARNING_THRESHOLD = -5;

/**
 * Calcola lo stato di una scadenza todo
 * @returns {'alert' | 'warning' | 'intime'}
 */
var todoDateDiff = helper(function todoDateDiff([date1, date2, daysBefore]) {
  if (!date1 || !date2 && daysBefore == null) return undefined;
  const resolveDate = d => moment(d === 'now' ? new Date() : d).startOf('day');
  const startDate = resolveDate(date1);
  let endDate = resolveDate(date2 ?? new Date());

  // Date invalide → NaN nel diff, che cadrebbe silenziosamente su 'intime'
  if (!startDate.isValid() || !endDate.isValid()) return undefined;

  // Usa != null per gestire daysBefore=0 (nessun anticipo, stesso giorno)
  if (daysBefore != null) {
    const offset = parseInt(daysBefore, 10);
    if (isNaN(offset)) return undefined;
    endDate = endDate.subtract(offset, 'days');
  }
  const daysDiff = startDate.diff(endDate, 'days');
  if (daysDiff > ALERT_THRESHOLD) return 'alert';
  if (daysDiff > WARNING_THRESHOLD) return 'warning';
  return 'intime';
});

export { todoDateDiff as default };
//# sourceMappingURL=todo-date-diff.js.map
